import { AddressSummaryFormUS } from '@/components/slides/DataSummary/us/SummaryForms/AddressSummaryFormUS';
import { ContactSummaryFormUS } from '@/components/slides/DataSummary/us/SummaryForms/ContactSummaryFormUS';
import { NameSummaryFormUS } from '@/components/slides/DataSummary/us/SummaryForms/NameSummaryFormUS';
import { PersonalInfoSummaryFormUS } from '@/components/slides/DataSummary/us/SummaryForms/PersonalInfoSummaryFormUS';
import { ContactPersonSummaryFormUS } from '@/components/slides/DataSummary/us/SummaryForms/ContactPersonSummaryFormUS';
import { AddressOptionsSummaryFormUS } from '@/components/slides/DataSummary/us/SummaryForms/AddressOptionsSummaryFormUS';

export const SummaryFormsUS = () => {
  return (
    <>
      <NameSummaryFormUS />
      <ContactSummaryFormUS />
      <AddressSummaryFormUS />
      <AddressOptionsSummaryFormUS />
      <PersonalInfoSummaryFormUS />
      <ContactPersonSummaryFormUS />
    </>
  );
};
